import useSubscription from "hooks/useSubscription";
import { SubscriptionStatus } from "types/organisation";

function usePaymentOverdueBannerEligibility(): boolean {
  const subscription = useSubscription();
  if (!subscription) return false;

  return subscription.status === SubscriptionStatus.PastDue || subscription.status === SubscriptionStatus.Unpaid;
}

export default usePaymentOverdueBannerEligibility;
